import React from "react";
import "../../styles/Expense_Tracker/Styles_Account_Balance.css";
import {connect} from "react-redux";
import {killSession} from "../../actions/Auth";

const Account_Balance_Sumary = (props) => {
    return (
        <div className="view_expenses_container">
            <div className="view_expenses_main">
                <div className="header">
                    <div className="expenses_balance_container">
                        <p className="title">Your Balance</p>
                        <div className="balance">
                            <p>${props.balance_amount}</p>
                        </div>
                    </div>

                    <div className="kill-session-btn">
                        <button onClick={() => {
                            props.killSession()
                        }}>Sign Out</button>
                    </div>
                </div>

                <div className="footer">
                    <div className="expenses_table">
                        <div className="income">
                            <p className="title">INCOME</p>
                            <p className="balance">${props.income_balance}</p>
                        </div>

                        <div className="expense">
                            <p className="title">EXPENSE</p>
                            <p className="balance">${props.expense_balance}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch) => ({
    killSession: () => dispatch(killSession())
});

export default connect(undefined, mapDispatchToProps)(Account_Balance_Sumary);